import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { StatsigClient } from '@statsig/js-client';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatsigService {
  public voiceFeature$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private initialized: boolean = false;
  private statsigClient: StatsigClient;

  // Test-only getters
  public get isInitialized(): boolean {
    return this.initialized;
  }

  public get client(): StatsigClient | undefined {
    return this.statsigClient;
  }

  // Test-only setter for client
  public setClientForTest(client: StatsigClient, initialized: boolean): void {
    this.statsigClient = client;
    this.initialized = initialized;
  }

  async initializeStatsig(userId: string): Promise<void> {
    if (this.initialized && userId) return;

    try {
      this.statsigClient = new StatsigClient(
        environment.statsigKey,
        { userID: userId },
        { environment: { tier: environment.serviceEnvironment } }
      );

      await this.statsigClient.initializeAsync();
      this.initialized = true;
    } catch (error) {
      console.error('Failed to initialize Statsig:', error);
    }
  }

  async checkFeatureGate(featureName: string): Promise<boolean> {
    if (!this.initialized) {
      throw new Error('Statsig is not initialized yet.');
    }
    return this.statsigClient.checkGate(featureName);
  }

  async waitForInitialization(): Promise<void> {
    if (this.initialized) return;
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (this.initialized) {
          clearInterval(interval);
          resolve();
        }
      }, 50);
    });
  }
}
